import React, { useState, useContext, useEffect } from 'react';
import { View, Text, Pressable } from 'react-native';
import {
  ContentContainer,
  MainContainer,
  SubNavContainerFullWidth,
  LinkContainer,
  LinkSpace,
  PageTitle
} from '../../../elements';
import Input from 'app/src/elements/inputs';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import DataTable from '@preflighttech/preflight-tables';
import SubNav from '../../../elements/SubNav';
import AuthContext from '../../../contexts/AuthContext';
import { BUYER_SALES_WITH_COUNT } from './queries';
import { SALE } from '../queries';
import { Link } from 'app/src/utils/routing';
import Modal from '../../../elements/Modal';
import NewBuyerSale from './new';
import EditBuyerSale from './edit';

const BuyerSales = (props) => {
  const { id } = useParams();
  const [sale, setSale] = useState();
  const [showAddBuyerSaleModal, setShowAddBuyerSaleModal] = useState(false);
  const [showEditBuyerSaleModal, setShowEditBuyerSaleModal] = useState(false);
  const [clickedBuyerSale, setClickedBuyerSale] = useState();
  const [refetch, setRefetch] = useState();
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const { hasPolicy } = useContext(AuthContext);

  const { loading, error, data } = useQuery(
    SALE, { variables: { id: id } }
  );

  const queryVariables = {
    saleId: id
  };

  useEffect(() => {
    if(data) {
      setSale(data.sale)
    }
  }, [data])

  const columns = [
    {
      key: 'buyer',
      label: 'Buyer',
      content: (entry) => entry.entry.buyer?.name,
      value: ({ value }) => value.name
    },
    {
      key: 'paddleService',
      label: 'Paddle Service',
      sort: 'prevent',
      content: (entry) => {
        return `${entry.entry.paddleService?.code}-${entry.entry.paddleNumber}`
      }
    },
    {
      key: 'functions',
      label: 'Functions',
      sort: 'prevent',
      content: (entry) => {
        return (
          <View style={{display: 'inline-flex'}}>
            <LinkContainer>
              <Pressable
                onPress={() => {
                  setClickedBuyerSale(entry.entry);
                  setShowEditBuyerSaleModal(true);
                }}
              >
                <Text>Edit</Text>
              </Pressable>
            </LinkContainer>
          </View>
        )
      }
    }
  ]

  return (
    <MainContainer>
      <SubNavContainerFullWidth>
        <SubNav>
          {getSubNavContents()}
        </SubNav>
      </SubNavContainerFullWidth>
      <ContentContainer>
      <PageTitle>{`${sale?.name} Buyers`}</PageTitle>
      <DataTable.Gql
        setRefetch={setRefetch}
        query={BUYER_SALES_WITH_COUNT}
        queryName='buyerSalesWithCount'
        queryVariables={queryVariables}
        columns={columns}
        pageLength={25}
        lengthMenu={ [10, 25, 50, 'All'] }
        htmlTable
      />
      </ContentContainer>
      {showEditBuyerSaleModal &&
        <Modal
          refetch={refetch}
          showModal={showEditBuyerSaleModal}
          setShowModal={setShowEditBuyerSaleModal}
          modalType={'Edit Sale Buyer'}
          objectName={clickedBuyerSale.buyer.name}
        >
          <EditBuyerSale
            setShowModal={setShowEditBuyerSaleModal}
            refetch={refetch}
            buyerSale={clickedBuyerSale}
          />
        </Modal>
      }
    </MainContainer>
  )

  function getSubNavContents() {
    return (
      <View>
        {getLinks()}
      </View>
    )
    function getLinks() {
      // if (!hasPolicy({ type: 'BuyerSale', action: 'create' })) {
      //   return null;
      // }

      return (
        <LinkContainer>
          <View style={{width: 'fit-content'}}>
            <Link to={`/sales/${sale?.id}`}>
              <Text>{sale?.name}</Text>
            </Link>
          </View>
          <Pressable
            style={{marginLeft: '30px'}}
            onPress={() => setShowAddBuyerSaleModal(true)}
          >
            <Text>+ Add Sale Buyer</Text>
          </Pressable>
          {showAddBuyerSaleModal &&
            <Modal
              showModal={showAddBuyerSaleModal}
              setShowModal={setShowAddBuyerSaleModal}
              modalType='Add Sale Buyer'
            >
              <NewBuyerSale
                setShowModal={ setShowAddBuyerSaleModal }
                sale={sale}
                refetch={refetch}
              />
            </Modal>
          }
        </LinkContainer>
      )
    }
  }
}

export default BuyerSales;